export default function reducer(state = {}, action) {
  switch (action.type) {
    case 'FILTER_LIST':
      return action.payload;

    default:
      return state;
  }
}
